// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_NUu","cls2":"FriendlySutdModal-cls2_vVP FriendlySutdModal-cls1_NUu","active":"FriendlySutdModal-active_STC","first":"FriendlySutdModal-first_RrO"};